// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"63ffdab1","543":"c190997c","614":"cc0b6381","757":"78b455ee","779":"f94de560","829":"7e3f9536","988":"837d99f8"}[chunkId] + ".chunk.js";
};